import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { mcpService } from '../services/mcpService';
import { Surface } from '../components/ui/Surface';

const OAUTH_POPUP_EVENT = 'mcp_oauth_complete';
const OAUTH_STORAGE_KEY = 'mcp_oauth_last_complete_at';

export const McpOauthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState('Completing OAuth authorization...');

  useEffect(() => {
    const run = async () => {
      const params = new URLSearchParams(window.location.search);
      const state = params.get('state') || '';
      const adminConsent = params.get('admin_consent');
      const msTenantId = params.get('tenant') || '';
      const code = params.get('code') || undefined;
      const error = params.get('error') || undefined;

      if (!state) {
        setMessage('Missing OAuth state. Please restart authorization.');
        return;
      }

      try {
        // Microsoft admin consent redirects with admin_consent=True + tenant=<id>, no code.
        if (adminConsent === 'True' && msTenantId) {
          await mcpService.completeAdminConsent({ agentInstanceId: state, msTenantId });
          setMessage('Organization authorization successful. You can close this window.');
          toast.success('Microsoft 365 Calendar authorized for your organization');
        } else {
          await mcpService.completeManagedOAuth({ state, code, error });
          setMessage('Authorization successful. You can close this window.');
          toast.success('MCP OAuth connected');
        }

        try {
          localStorage.setItem(OAUTH_STORAGE_KEY, String(Date.now()));
        } catch {
          // Ignore storage failures.
        }

        if (window.opener && !window.opener.closed) {
          window.opener.postMessage({ type: OAUTH_POPUP_EVENT }, window.location.origin);
          window.close();
        } else {
          setTimeout(() => navigate('/agents'), 1500);
        }
      } catch (e: any) {
        setMessage(e?.message || 'OAuth completion failed');
        toast.error(e?.message || 'OAuth completion failed');
      }
    };

    run();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-agentic-white-off p-6">
      <Surface className="mx-auto mt-16 max-w-xl rounded-xl border border-agentic-gray-200 bg-white p-6 shadow-card">
        <h1 className="text-xl font-semibold text-agentic-text-primary">MCP OAuth Callback</h1>
        <p className="mt-3 text-agentic-text-secondary">{message}</p>
      </Surface>
    </div>
  );
};

export default McpOauthCallback;
